import { Route, Routes } from "react-router-dom";
import { ViewWWAdmins } from "./View/ViewWWAdmins";
import { CreateWWAdmin } from "./Create/CreateWWAdmin";
import { EditWWAdmin } from "./Edit/EditWWAdmin";

export const WWAdminManagement = () => {
  return (
    <Routes>
      <Route index element={<ViewWWAdmins />} />
      <Route path="create" element={<CreateWWAdmin />} />
      <Route path="edit" element={<EditWWAdmin />} />
    </Routes>
  );
};
